import React, { Component } from 'react';
import moment from 'moment-timezone';
import Modal from "antd/lib/modal/Modal";
import { Table, message, DatePicker, Select } from 'antd';
import Loader from '../../../../../Common/Component/Loader';
import LogPayment from '../../Common/LogPayment';

import { map } from 'lodash';
import DataTable from '../DataTable';

const { Option } = Select;
const { RangePicker } = DatePicker;
class PaymentHistory extends Component {
    state = {
      payment_history_list: [],
      customerList: [],
      payment_history_list_pagination: { current: 1, showSizeChanger: false, pageSize: 10, ordering: "" },
      payment_history_filter: { received_by__uuid: '', search: '', cheque_payment: false, cash_payment: false, created_at__lte: '', created_at__gte: '' },
      loader: false
    }
    componentDidMount = () => {
      //Get Payment History
      this.props.getPaymentHistory({ invoice__uuid: this?.props?.invoice_uuid, limit: 10, offset: 0 });

      //List of customer
      this.props.getCustomers({ limit: 10, offset: 0 })
      this.setState({ loader:true});
    }

    UNSAFE_componentWillReceiveProps = (props) => {
      let { payment_history_list_pagination } = this.state;

      if (Object.keys(props?.PaymentHistory?.data).length > 0 && props.PaymentHistory.data !== this.props.PaymentHistory.data) {
        payment_history_list_pagination.total = props?.PaymentHistory?.data?.count ? props?.PaymentHistory?.data?.count : 0

        this.setState({
          payment_history_list: props.PaymentHistory.data,
          payment_history_list_pagination,
          loader: false
        })
      }
      else 
      {
        this.setState({loader: false})
      }

      if (Object.keys(props?.PaymentHistory?.data).length > 0 && props?.PaymentHistory?.data !== this.props?.PaymentHistory?.data) {
        payment_history_list_pagination.total = props?.PaymentHistory?.data?.count ? props?.PaymentHistory?.data?.count : 0;

        this.setState({
          payment_history_list: props.PaymentHistory.data,
          payment_history_list_pagination,
          loader: false
        })
      }

      if (Object.keys(props.PaymentHistory.errors).length > 0 && props.PaymentHistory.errors !== this.props.PaymentHistory.errors) {
        message.error('Something went wrong', 10);
        this.setState({
          loader: false,
        })
      }

      //Get Customer List
      if (Object.keys(props.CustomerList.customerList).length > 0 && props.CustomerList.customerList !== this.props.CustomerList.customerList) {
        this.setState({
          customerList: props.CustomerList.customerList.results,
          set_table_active_action: ''
        })
      }

      if (Object.keys(props.CustomerList.errors).length > 0 && props.CustomerList.errors !== this.props.CustomerList.errors) {
        message.error('Something went wrong', 10);
        this.setState({loader: false,});
      }
    }

    // Table Pagination
    onHistoryChange = (pagination) => {
      let { payment_history_list_pagination, payment_history_filter } = this.state;
      payment_history_list_pagination = Object.assign(payment_history_list_pagination, { 'current': pagination.current });

      this.setState({
        payment_history_list_pagination,
        loader: true
      })

      let data = {
        offset: (pagination.current * 10) - 10,
        limit: 10,
        ...payment_history_filter
      }

      Object.keys(data).forEach((key) => (data[key] === null || data[key] === '' || !data[key]) && delete data[key]);
      this.props.getPaymentHistory({ invoice__uuid: this?.props?.invoice_uuid, ...data });
    }

    //Render Service History table
    renderHistoryTable = () => {
      let { payment_history_list, payment_history_list_pagination } = this.state;
      return (
        <React.Fragment>
          <Table
            rowKey={record => record.uuid}
            dataSource={payment_history_list}
            onChange={this.onHistoryChange}
            pagination={payment_history_list_pagination}
            columns={DataTable.AllHistoryList(this)} />
        </React.Fragment>
      )
    }

    //History Table
    onHistoryFilter = () => {
      let { payment_history_list_pagination, payment_history_filter } = this.state;

      this.setState({
        payment_history_list_pagination,
        loader: true
      })

      let data = {
        offset: (payment_history_list_pagination.current * 10) - 10,
        limit: 10,
        ...payment_history_filter,
        invoice__uuid: this?.props?.invoice_uuid
      }
     
      Object.keys(data).forEach((key) => (data[key] === null || data[key] === '' || !data[key]) && delete data[key]);
      // this.props.getPaymentHistory(data);
      this.props.getPaymentHistory(data);
    }

    toggleLog = () => {
      this.setState({show_edit_payment: !this.state.show_edit_payment});
    }

    onUpdated = (success) => {
      if(success)
      {
        message.success("Your payment was successfuly updated", 5);
        this.props.getPaymentHistory({invoice__uuid: this?.props?.invoice_uuid, limit: 10, offset: 0 });
        this.props.getInvoiceSummary({user__uuid: this.props?.customerId });
      }
      else
      {
        message.error("Your payment cannot be done", 5);
      }

      this.props.cleanPaymentResponse();
    }

    toggleLoader = () => {
      this.setState({loader: !this.state.loader});
    }

    onDelete = () => {
      let { selected_payment} = this.state;
      this.props.deletePaymentLog(selected_payment.uuid).then(() => {
        message.success("The Payment was successfuly deleted", 15);
        this.props.getPaymentHistory({ invoice__uuid: this?.props?.invoice_uuid, limit: 10, offset: 0 });
        this.props.getInvoiceSummary({user__uuid: this.props?.customerId });
      });
      this.setState({show_delete_modal: false})
    }

    render() {
      let { loader, payment_history_filter, customerList, show_delete_modal, selected_payment, show_edit_payment, edit } = this.state;
      return (<>
        <Modal
          visible={show_delete_modal}
          okText={"Delete"}
          cancelText={"Cancel"}
          onOk={this.onDelete}
          onCancel={() => {
            this.setState({show_delete_modal: false})
          }}
          className="delete_user_modal"
          width={400}
        >   
          <h3>{`Delete Payment`}</h3>
          <p>{`Are you sure you would like to delete this Payment?`}</p>
        </Modal>

        {show_edit_payment &&
          <LogPayment
            edit={edit}
            payment={selected_payment}
            visible={show_edit_payment}
            closeDrawer={this.toggleLog}
            toggleLoader={this.toggleLoader}
            customerId={this.props.customerId}
            invoice_uuid={selected_payment.invoice_uuid}
            onUpdated={this.onUpdated}
            // API
            getInvoiceList={this.getInvoiceList}
            getInvoiceSummary={this.getInvoiceSummary}
            getCustomers={this.props.getCustomers}
            addPaymentLog={this.props.addPaymentLog}
            getCardList={this.props.getCardList}
            addNewCard={this.props.addNewCard}
            getStaffUsers={this.props.getStaffUsers}
            postPaymentLog={this.props.postPaymentLog}
            cleanPaymentResponse={this.props.cleanPaymentResponse}
            // Reducers
            customerList={this.props.CustomerList}
            cardList={this.props.CardList}
            addCard={this.props.AddCard}
            customer={this.props.Customer}
            addedLog={this.props.AddedLog}
            Invoice={this.props.Invoice}
            PostPaymentLog={this.props.PostPaymentLog}
          />
        }

        <div className="account_expired_card">
          <div className="filter_wrapper flex full_date_range_picker">
            <div className="form-group flex ai-center fltr-txt" style={{ width: '100%' }}>
              <div className="fitem" style={{ width: '100%' }}>
                <RangePicker
                  format={'MM/DD/YYYY'}
                  className="date_ranger dwhite"
                  dropdownClassName="dropdown_date_range"
                  suffixIcon={<i className="las la-angle-down"></i>}
                  onChange={(e) => {
                    if (e) {
                      payment_history_filter = Object.assign(payment_history_filter, { created_at__gte: `${moment(e[0]).format('YYYY-MM-DD')}T00:00:00`, created_at__lte: `${moment(e[1]).format('YYYY-MM-DD')}T00:00:00` });
                    }
                    else {
                      payment_history_filter = Object.assign(payment_history_filter, { created_at__gte: '', created_at__lte: '' });
                    }

                    this.setState({
                      payment_history_filter
                    });
                    this.onHistoryFilter();
                  }}
                />
              </div>
              <div className="fitem" >
                <Select
                  className="swhite filter_type"
                  placeholder="Payment Type"
                  defaultValue=""
                  onChange={(e) => {
                    if (e === 'cash') {
                      payment_history_filter = Object.assign(payment_history_filter, { cash_payment: true, cheque_payment: false });
                    }
                    if (e === 'check') {
                      payment_history_filter = Object.assign(payment_history_filter, { cash_payment: false, cheque_payment: true });
                    }
                    if (e === '') {
                      payment_history_filter = Object.assign(payment_history_filter, { cash_payment: false, cheque_payment: false });
                    }

                    this.setState({
                      payment_history_filter
                    });
                    this.onHistoryFilter()
                  }}
                > <Option value="">All</Option>
                  <Option value="cash">Cash</Option>
                  <Option value="check">Check</Option>
                </Select>
              </div>
              <div className="fitem" style={{ width: '100%' }}>
                <input
                  style={{ background: '#ffffff', height: '35px' }}
                  value={payment_history_filter?.search}
                  onChange={(e) => {
                    payment_history_filter = Object.assign(payment_history_filter, { search: e.target.value });
                    this.setState({
                      payment_history_filter
                    })
                    this.onHistoryFilter();
                  }}

                  type="text"
                  className="swhite filter_type"
                  placeholder="Received From / Check ID" />
              </div>
              {/* <div className="fitem">
              <input
                style={{ background: '#ffffff', height: '35px' }}
                value={payment_history_filter?.cheque_id}
                onChange={(e) => {
                  payment_history_filter = Object.assign(payment_history_filter, { cheque_id: e.target.value, received_from: '' });
                  this.setState({
                    payment_history_filter
                  })
                  this.onHistoryFilter();
                }}
                type="text"
                className="swhite filter_type"
                placeholder="Check ID" />
            </div> */}
              <div className="fitem" style={{ width: '100%' }}>
                <Select
                  className=" swhite filter_type"
                  placeholder="Received By"
                  onChange={(e) => {
                    payment_history_filter = Object.assign(payment_history_filter, { received_by__uuid: e });
                    this.setState({
                      payment_history_filter
                    })
                    this.onHistoryFilter();
                  }}
                  showSearch
                  onSearch={(e) => {
                    this.props.getCustomers({ q: e })
                  }}
                  onBlur={() => {
                    this.props.getCustomers({ limit: 10, offset: 0 })
                  }}
                >
                  <Option value="">All</Option>
                  {map(customerList, (item) => {
                    return (
                      <Option key={item.uuid}>{item.first_name} {item.last_name}</Option>
                    )
                  })}
                </Select>
              </div>
            </div>
          </div>
          <ul className="breadcrumb">
            <li onClick={() => { this.props.onChangeView(0) }}>
              <span className="pointer"><i className="las la-angle-left"></i> Back to All Accounts</span>
            </li>
          </ul>
          <h2 style={{ 'padding': '0 25px 0 25px', 'margin': '0' }}>Payment History</h2>
          <div className="block-row pt-10">
            {this.renderHistoryTable()}
          </div>
          {loader ? <Loader /> : ''}
        </div>
      </>);
    }
}

export default PaymentHistory;